<template>
  <div>
    <pageTable
      :col="col"
      :loading="tableLoading"
      :data="data"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @compFn="customCompFunc"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
    <full-diag :isShow="FullImgShow" @close="toggleFullImg(false)">
      <div class="full-img-content">
        <img :src="imgUrl" alt="">
      </div>
    </full-diag>
  </div>
</template>

<script>
import Vue from 'vue'
import fullDiag from '@/components/dialogs/fullDiag'
import pageTable from '@/components/pageCom/pageTable.vue'
import { getExamineDetail } from '@/api/app'
export default {
  name: 'detailList',
  components: {
    pageTable,
    fullDiag
  },
  data() {
    return {
      newCol: [ // 信息认证审核
        { field: 'cay_approval_opinion', title: '驳回原因', width: 120, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            return `<span class='cell-edit-color' title="${rowData[field]}">${rowData[field]}</span>`
          } },
        { field: 'cay_comfirm_type', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '2') {
              return `<span class='cell-edit-color' style="color: #DE2F2F">驳回</span>`
            } else if (rowData[field] === '3') {
              return `<span class='cell-edit-color' style="color: #2BB968">通过</span>`
            }
          } },
        { field: 'create_time', title: '提交时间', width: 150, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_no', title: '企业编码', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_type', title: '企业类型', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>商业公司</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>服务商</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>药品生产企业</span>`
            }
          } },
        { field: 'cay_nature', title: '企业性质', width: 130, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>企业</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>个体工商户</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>政府机关/事业单位</span>`
            }
          } },
        { field: 'cay_name', title: '企业名称', width: 220, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_tel', title: '联系电话', width: 110, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_social_credit_code', title: '统一社会信用代码', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_license', title: '营业执照注册号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_tax_registration', title: '税务登记号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_organization_code', title: '组织机构代码证', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_corp_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_passport_no', title: '护照', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_corp_idcard', title: '身份证号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_certigier_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_certigier_idcard', title: '身份证号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_cell_phone', title: '手机', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_adm_email', title: '电子邮箱', width: 180, titleAlign: 'left', columnAlign: 'left' }
      ],
      newUkeyCol: [ // Ukey审核表头
        { field: 'cay_approval_opinion', title: '驳回原因', width: 120, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            return `<span class='cell-edit-color' title="${rowData[field]}">${rowData[field]}</span>`
          } },
        { field: 'cay_comfirm_type', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '2') {
              return `<span class='cell-edit-color' style="color: #DE2F2F">驳回</span>`
            } else if (rowData[field] === '3') {
              return `<span class='cell-edit-color' style="color: #2BB968">通过</span>`
            }
          } },
        { field: 'cay_no', title: '企业编码', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'cay_type', title: '企业类型', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>商业公司</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>服务商</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>药品生产企业</span>`
            }
          } },
        { field: 'cay_nature', title: '企业性质', width: 130, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>企业</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>个体工商户</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>政府机关/事业单位</span>`
            }
          } },
        { field: 'cay_name', title: '企业名称', width: 220, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'certificateUrl', title: '天威授权书', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'newCertificateUrl' },
        { field: 'signatureUrl', title: '签章', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'newSignatureUrl' },
        { field: 'cay_receive_name', title: '收件人姓名', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'cay_receive_address', title: '收件人地址', width: 220, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'cay_receive_tel', title: '联系电话', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true }
      ],
      ruanZhengShuCol: [ // 软证书审核表头
        { field: 'cay_approval_opinion', title: '驳回原因', width: 120, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            return `<span class='cell-edit-color' title="${rowData[field]}">${rowData[field]}</span>`
          } },
        { field: 'cay_comfirm_type', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '2') {
              return `<span class='cell-edit-color' style="color: #DE2F2F">驳回</span>`
            } else if (rowData[field] === '3') {
              return `<span class='cell-edit-color' style="color: #2BB968">通过</span>`
            }
          } },
        { field: 'cay_no', title: '企业编码', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'cay_type', title: '企业类型', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>商业公司</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>服务商</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>药品生产企业</span>`
            }
          } },
        { field: 'cay_nature', title: '企业性质', width: 130, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>企业</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>个体工商户</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>政府机关/事业单位</span>`
            }
          } },
        { field: 'cay_name', title: '企业名称', width: 220, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'certificateUrl', title: '天威授权书', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'newCertificateUrl' },
        { field: 'signatureUrl', title: '签章', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'newSignatureUrl' },
        { field: 'uk_no', title: '证书编码', width: 400, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      data: [],
      col: [],
      total: 0,
      FullImgShow: false, // 查看图片弹窗是否开启
      imgUrl: '', // 查看图片弹窗的url
      pageSize: 30,
      page: 1,
      tableLoading: false, // 表格loading
      licenseType: '', // 证书类型 0 ukey 1软证书 -1默认
      companyId: '', // 企业编码
      corpTypeKey: '' // 1 认证信息 2 ukey认证
    }
  },
  created() {
    this.tableLoading = true
    this.$store.dispatch('setPage', { title: '查看明细', type: 'cover' })
    this.corpTypeKey = this.$route.params.id
    if (this.$route.params.id.toString() === '1') {
      this.col = this.newCol
    } else if (this.$route.params.id.toString() === '2') {
      this.col = this.newUkeyCol
    } else {
      this.col = this.ruanZhengShuCol
    }
    this.companyId = this.$route.query.cayNo
    this.licenseType = this.$route.params.id - 2
    this._getExamineDetail()
  },
  methods: {
    toggleFullImg(flag) {
      this.FullImgShow = flag
    },
    // 改变分页的方法
    pageChange(page) {
      this.page = page
      this._getExamineDetail()
    },
    // 改变每页多少条的方法
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.page = 0
      this._getExamineDetail()
    },
    _getExamineDetail() {
      getExamineDetail(this.licenseType, this.corpTypeKey, this.companyId, this.pageSize, this.page).then(res => {
        if (res.code === 0) {
          this.tableLoading = false
          this.data = res.result.data
        }
      })
    },
    // 审核弹窗
    customCompFunc(data) {
      if (data.type === 'certificateUrl') {
        this.imgUrl = data.certificateImgUrl
        this.FullImgShow = true
      } else if (data.type === 'signatureUrl') {
        this.imgUrl = data.signatureImgUrl
        this.FullImgShow = true
      }
    }
  }
}
Vue.component('newCertificateUrl', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    verify() {
      const verifyData = {
        type: 'certificateUrl',
        certificateImgUrl: this.rowData.cay_certificate_url
      }
      this.$emit('on-custom-comp', verifyData)
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        lookImg: true
      }
    }, [h('a', {
      on: {
        click: this.verify
      }
    }, '授权书.jpg')])
  }
})
Vue.component('newSignatureUrl', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    verify() {
      const verifyData = {
        type: 'signatureUrl',
        signatureImgUrl: this.rowData.cay_official_seal_url
      }
      this.$emit('on-custom-comp', verifyData)
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        lookImg: true
      }
    }, [h('a', {
      on: {
        click: this.verify
      }
    }, '签章.jpg')])
  }
})
</script>

<style scoped>

</style>
